<div class='back-to-dashboard'>
    <a class="bread-crumb w-auto" [routerLink]="['../../dashboard']">
        <mat-icon aria-hidden="false" aria-label="Back to Dashboard">chevron_left</mat-icon>
        <span>{{ 'searchCustomer.backToDashboard' | translate}}</span>
    </a>
</div>
<div class="heading">
    {{ 'parts.scheduleparts' | translate}}
    <ng-container *ngIf="!editBool && (customerDetails$ | async)?.firstName">
        {{ 'delivery.for' | translate}} {{(customerDetails$ | async)?.firstName |titlecase }} {{(customerDetails$ |
        async)?.lastName |titlecase }}
    </ng-container>
    <ng-container *ngIf="editBool && customerDataOnEdit?.firstName">
        {{ 'delivery.for' | translate}} {{customerDataOnEdit?.firstName |titlecase }} {{customerDataOnEdit?.lastName
        |titlecase }}
    </ng-container>
</div>
<div class="container">
    <app-select-learning-vehicle [showMileageField]="false" [src]="src" (formEdited)="valuesChange($event)"
        [showPartsField]="true" [vehicleInfo]="vehicleInfo"></app-select-learning-vehicle>

    <div [formGroup]="partsAppointmentForm">
        <mat-expansion-panel [expanded]="!showMandatoryMsgCI && isUpdate">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class='comments-header'>
                        {{ 'otherTexts.customerInformation' | translate}}
                    </div>
                </mat-panel-title>
                <mat-panel-description class="form-status">
                    <span class="in-complete" *ngIf="!showMandatoryMsgCI">Incomplete</span>
                    <span class="complete" *ngIf="showMandatoryMsgCI">Complete</span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <app-contact-email-info formControlName="customer" (isCIformValid)="isCIformValid($event)"
                [apptType]="apptType"></app-contact-email-info>
        </mat-expansion-panel>


        <app-trade-in-info formControlName="tradeIn" from='learning'></app-trade-in-info>

        <mat-expansion-panel [expanded]="!partsAppointmentForm.controls.availability.valid && isUpdate"
            style="margin-top: 2rem;">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class='comments-header'>
                        {{ 'service.appointmentAvailability' | translate}}
                    </div>
                </mat-panel-title>
                <mat-panel-description class="form-status">
                    <span class="in-complete" *ngIf="!partsAppointmentForm.controls.availability.valid">Incomplete</span>
                    <span class="complete" *ngIf="partsAppointmentForm.controls.availability.valid">Complete</span>
                </mat-panel-description>
            </mat-expansion-panel-header>


            <app-availability *ngIf="editBool && languageId!==''; else noEdit" class='app-availability'
                formControlName='availability' [options]="availabilityOptions$ | async"
                [isAvailabilityLoading]="availabilityLoading$ | async" [availability]="availability$ | async"
                [apptType]="apptType" [selectedTransport]="'DEALER'" (monthChanged)="onMonthChange($event)"
                (formEdited)="valuesChange($event)" [showClearDateTimeBtn]="true" [isEditMode]="editBool"
                [customerLanguage]="languageId" [appointmentId]="appointmentId">
            </app-availability>
            <ng-template #noEdit>
                <app-availability class='app-availability' formControlName='availability'
                    [options]="availabilityOptions$ | async" [isAvailabilityLoading]="availabilityLoading$ | async"
                    [availability]="availability$ | async" [apptType]="apptType" [selectedTransport]="'DEALER'"
                    (monthChanged)="onMonthChange($event)" (formEdited)="valuesChange($event)"
                    [showClearDateTimeBtn]="true">
                </app-availability>
            </ng-template>
        </mat-expansion-panel>
    </div>
</div>
<div class="testdrive-content" id="inquiry-sticky-footer">
    <div id="accept-terms">
        <span class="label">
            {{getDisclaimerText}}
        </span>
    </div>

    <div class='appointment-submit'>
        <button class='submit' [class.submitting]="isSubmitting" [ngClass]="isValidForm() ? 'enabled':'btn-disabled'"
            (click)="onSubmit()" [disabled]="isSubmitting">
            <ng-container *ngIf="isSubmitting; else partsSubmitLabel">
                <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="white" [size]=".7" [compact]="true"></app-loading>
            </ng-container>
            <ng-template #partsSubmitLabel>
                {{'testDrive.submit' | translate}}
            </ng-template>
        </button>
    </div>

    <div class='appointment-details' *ngIf="isValidForm()">
        {{'testDrive.theAppointmentIsOn' |
        translate}}{{getTranslation(partsAppointmentForm.get('availability')?.value?.appointmentStartDate | date :
        'MMMM')}} {{ partsAppointmentForm.get('availability')?.value?.appointmentStartDate | date : ' dd' }}
        {{'testDrive.aT' | translate}} {{ partsAppointmentForm.get('availability')?.value?.timeSlotId }} at
        {{ partsAppointmentForm.get('transportationTypeCode').value == 'REMOTE' ? ('testDrive.atRemoteLocation' |
        translate) : ('testDrive.atDealershipLocation' | translate) }}
    </div>
</div>